import { render, staticRenderFns } from "./IscriviSquadra.vue?vue&type=template&id=e74bec92&scoped=true&"
import script from "./IscriviSquadra.vue?vue&type=script&lang=js&"
export * from "./IscriviSquadra.vue?vue&type=script&lang=js&"
import style0 from "./IscriviSquadra.vue?vue&type=style&index=0&id=e74bec92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74bec92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e74bec92')) {
      api.createRecord('e74bec92', component.options)
    } else {
      api.reload('e74bec92', component.options)
    }
    module.hot.accept("./IscriviSquadra.vue?vue&type=template&id=e74bec92&scoped=true&", function () {
      api.rerender('e74bec92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/IscriviSquadra.vue"
export default component.exports